import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AddRepoter = () => {
  const navigate = useNavigate();
  const apiBase = useMemo(() => (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, ''), []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    address: '',
    image: null
  });
  const [preview, setPreview] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;

    if (type === 'file') {
      const file = files?.[0] || null;
      setFormData((prev) => ({ ...prev, image: file }));
      setPreview(file ? URL.createObjectURL(file) : '');
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const payload = new FormData();
    payload.append('name', formData.name);
    payload.append('email', formData.email);
    payload.append('mobile', formData.mobile);
    payload.append('address', formData.address);
    if (formData.image) payload.append('image', formData.image);

    try {
      setLoading(true);
      await axios.post(`${apiBase}/repoter`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Repoter added successfully');
      navigate('/repoters');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to add repoter');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Repoter</h4>
      </div>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row mx-4">
          <div className="col-sm-6 mt-4">
            <label className="adminlables" htmlFor="name">
              Name
            </label>
            <input
              id="name"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-4">
            <label className="adminlables" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-4">
            <label className="adminlables" htmlFor="mobile">
              Mobile
            </label>
            <input
              id="mobile"
              name="mobile"
              className="form-control"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-4">
            <label className="adminlables" htmlFor="image">
              Image
            </label>
            <input id="image" type="file" name="image" className="form-control filebg" accept="image/*" onChange={handleChange} />
          </div>

          <div className="col-sm-12 mt-4">
            <label className="adminlables" htmlFor="address">
              Address
            </label>
            <textarea
              id="address"
              name="address"
              className="form-control"
              rows="3"
              value={formData.address}
              onChange={handleChange}
            />
          </div>
        </div>

        {preview ? (
          <div className="mx-4 mt-3">
            <p className="text-white mb-2">Image Preview</p>
            <img src={preview} alt="Repoter preview" width={130} className="rounded" />
          </div>
        ) : null}

        <div className="mt-5 text-right mx-4">
          <button className="btn btn-lg addbtn" type="submit" disabled={loading}>
            {loading ? 'Adding...' : 'Add Repoter'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddRepoter;
